/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiAssistant } from '../models/AiAssistant';
import type { AiEmailMessage } from '../models/AiEmailMessage';
import type { AiMessage } from '../models/AiMessage';
import type { AiRun } from '../models/AiRun';
import type { ChatExecutionRequest } from '../models/ChatExecutionRequest';
import type { ChatExecutionResponse } from '../models/ChatExecutionResponse';
import type { CustomerReference } from '../models/CustomerReference';
import type { GenerativeAIProductRequest } from '../models/GenerativeAIProductRequest';
import type { GenerativeAIProductResponse } from '../models/GenerativeAIProductResponse';
import type { PersonalizedProductPitch } from '../models/PersonalizedProductPitch';
import type { RunRequest } from '../models/RunRequest';
import type { StreamableFile } from '../models/StreamableFile';
import type { ThreadRequest } from '../models/ThreadRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AiService {

    /**
     * @param requestBody
     * @returns ChatExecutionResponse Chat
     * @throws ApiError
     */
    public static aiControllerChat(
        requestBody: ChatExecutionRequest,
    ): CancelablePromise<ChatExecutionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ai/chat',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static aiControllerTestAiFunctions(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ai/testAiFunctions',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static aiControllerGenerateMemories(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ai/generateMemories',
        });
    }

    /**
     * @param requestBody
     * @returns AiAssistant Assistant
     * @throws ApiError
     */
    public static aiControllerGetAssistant(
        requestBody: {
            applicationKey?: string,
            assistantKey?: string
          }): CancelablePromise<AiAssistant> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ai/getAssistant',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns AiRun sendMessage
     * @throws ApiError
     */
    public static aiControllerSendMessage(
        requestBody: AiMessage,
    ): CancelablePromise<AiRun> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ai/sendMessage',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns AiMessage loadMessages
     * @throws ApiError
     */
    public static aiControllerLoadMessages(
        requestBody: ThreadRequest,
    ): CancelablePromise<Array<AiMessage>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ai/loadMessages',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns AiRun loadRun
     * @throws ApiError
     */
    public static aiControllerLoadRun(
        requestBody: RunRequest,
    ): CancelablePromise<AiRun> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ai/loadRun',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns AiRun cancelRun
     * @throws ApiError
     */
    public static aiControllerCancelRun(
        requestBody: RunRequest,
    ): CancelablePromise<AiRun> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ai/cancelRun',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static aiControllerListFiles(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ai/listFiles',
        });
    }

    /**
     * @param fileId
     * @returns StreamableFile streamFile
     * @throws ApiError
     */
    public static aiControllerStreamFile(
        fileId: string,
    ): CancelablePromise<Array<StreamableFile>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ai/streamFile/{fileId}',
            path: {
                'fileId': fileId,
            },
        });
    }

    /**
     * @param requestBody
     * @returns string Message
     * @throws ApiError
     */
    public static aiControllerGeneratePersonalizedProductPitch(
        requestBody: PersonalizedProductPitch,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ai/generatePersonalizedProductPitch',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns GenerativeAIProductResponse Product Pitch
     * @throws ApiError
     */
    public static aiControllerCreateProductPitch(
        requestBody: GenerativeAIProductRequest,
    ): CancelablePromise<GenerativeAIProductResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ai/createProductPitch',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns string Confirmation Message
     * @throws ApiError
     */
    public static aiControllerSendAiInitiatedEmail(
        requestBody: AiEmailMessage,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ai/sendAiInitiatedEmail',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id
     * @returns CustomerReference Customer Reference
     * @throws ApiError
     */
    public static aiControllerGetCustomerInsights(
        id: string,
    ): CancelablePromise<CustomerReference> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ai/getCustomerInsights/{id}',
            path: {
                'id': id,
            },
        });
    }

}
